import { gql } from '@apollo/client'
import { getApolloClient } from '@libs/getApolloClient'
import { GetServerSidePropsContext } from 'next'

const TRENDING_KEYWORDS = gql`
  query TrendingKeywords {
    trendingKeywords
  }
`

type GetTrendingKeywordsParams = {
  ctx: GetServerSidePropsContext
}
async function getTrendingKeywords(params: GetTrendingKeywordsParams) {
  const { ctx } = params
  const client = getApolloClient(ctx)
  try {
    const response = await client.query({
      query: TRENDING_KEYWORDS,
    })
    return { ...response }
  } catch (error) {
    return { ...error }
  }
}

export default getTrendingKeywords
